/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetDealsMutationResponse,
  PerformSetDealsPathParams,
  PerformSetDeals404,
} from '../types/PerformSetDeals'

function getPerformSetDealsUrl({
  import_number,
}: {
  import_number: PerformSetDealsPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-deals/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-deals step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-deals/}
 */
export async function performSetDeals(
  {
    import_number,
  }: { import_number: PerformSetDealsPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PerformSetDealsMutationResponse,
    ResponseErrorConfig<PerformSetDeals404>,
    unknown
  >({
    method: 'POST',
    url: getPerformSetDealsUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
